import React from 'react';
import { compose } from 'redux';
import classNames from 'classnames';
import { Grid } from '@material-ui/core';
import withStyles from '@material-ui/styles/withStyles';

const SortableListRowIcon = ({ classes, children, transparent, ...props }) => (
  <Grid item className={classes.iconColumn} {...props}>
    <Grid
      classes={{
        root: classNames({
          [classes.transparent]: transparent,
        }),
      }}
    >
      {children}
    </Grid>
  </Grid>
);

const styles = (theme) => ({
  iconColumn: {
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: theme.altus.components.SortableListRow.height,
    minWidth: theme.altus.components.SortableListRow.height,
    height: theme.altus.components.SortableListRow.height - 1,
    background: theme.altus.components.SortableListRowIcon.background,
  },
  transparent: {
    background: 'transparent',
  },
});

SortableListRowIcon.defaultProps = {
  transparent: false,
};

export default compose(
  React.memo,
  withStyles(styles, {
    name: 'SortableListRowIcon',
  }),
)(SortableListRowIcon);
